export class ExtraFeeModel {
  id: string;
  name: string;
  limit: number;
  price = 0;
  defaultPriceLevelPrice = 0;
  ticketIds: string[];
  tag: string | null = null;

  quantity = 0;

  constructor(init?: Partial<ExtraFeeModel>) {
    Object.assign(this, init);
  }
}
